<template>
 <div class="container">
        <div class="wrap">
          <h2 style="text-align: center"><i class="fas fa-lock" style="margin-right: 20px"></i>Logowanie </h2>
          <div class="d-flex justify-content-center">
            <div class="col-lg-6 mb-6 order-2 order-lg-2">

              <div class="dialog modal-dialog-centered" style="text-align: center">
                <div class="content">
                  <div class="title">

                  </div>
                  <div class="Inputs">
                    <form>
                      <div class="PopupLogin">
                        <i class="fas fa-user"></i><input ref="input" type="text" class="form-control " placeholder="Email" v-model="creds['user']" @focus="err=''" @keyup.enter="doLogin"> <br>

                      </div>



                      <div class="PopupHaslo">

                        <!-- 
                        <i class="fas fa-lock"></i>
 -->

                        <div class="input-group ">

                          <input v-if="showPassword" ref="input" type="text" class="form-control " placeholder="Hasło" v-model="creds['passwd']" @focus="err=''" @keyup.enter="doLogin"> 
                          <input v-else ref="input" type="password" class="form-control " placeholder="Hasło" v-model="creds['passwd']" @focus="err=''" @keyup.enter="doLogin"> 


                          <span class="input-group-text">
                              <i class="far" :class="{ 'fa-eye-slash': !showPassword, 'fa-eye': showPassword }" id="togglePassword" @click="togglePass"
                              style="cursor: pointer"></i>
                          </span>



                        </div>
                      </div>






                      <div class="PopupError" style="text-align: left">
                        <p v-if="invalidUser" style="color:red;" class="validateUser">* Nazwa użytkownika nie może być pusta</p>
                        <p v-if="invalidPassword" style="color:red;" class="validatePassword">* Hasło nie może być puste</p>
                        <p v-if="invalidCreds" style="color:red;" class="validatePassword">* Nieprawidłowe dane logowania</p>
                      </div>
                    </form>
                  </div>
                  <div class="d-flex" style="text-align: center; align-content: center">
                    <b-row class="justify-content-center">

                      <b-col class="zalogujRow" md="7" xs="7">
                        <a class="form-button btn btn-outline-primary btn-lg me-2 login"  @click="doLogin" href="#" >Zaloguj</a>
                      </b-col>

                      <b-col md="7" xs="6" class="loginRow" style="margin-top: 10px">
                        <a class="" style="text-decoration: underline; " href="#" data-bs-toggle="modal" data-bs-target="#ForgotPasswordModal" id="zapomnialeshasla">Zresetuj hasło</a>
                      </b-col>

                    </b-row>
                  </div>

                </div>

              </div>
            </div>

          </div>
          <loading-screen :is-loading="isLoading"></loading-screen>
        </div>

 </div>

</template>
<script>
    import Loader from "./components/Loader";
    import ZetosForgotPassword from './components/ForgotPasssword';

    export default {

        components: {
            ZetosForgotPassword, 'loading-screen': Loader
        },
        data() {
            return {


                creds: {},

                showPassword: false,


                isDirty: false,
                isLoading:false,

                err: '',

                modal:null

            }
        },
        methods: {
            goToMainPage(){
                this.isLoading=true;
                setTimeout(() => {
                    this.isLoading = false
                }, 5000)
                this.$router.push('/#');
            },

           
            togglePass(){

                this.showPassword = !this.showPassword;
            },




            doLogin() {

                this.isDirty = true;


                if (this.invalidUser || this.invalidPassword) {
                    return;
                }


                this.isLoading=true;
                



                //    this.$emit('login');


                this.post( '/client/login', {

                    client_login: this.creds.user.trim(),
                    client_password: this.creds.passwd.trim()

                })
                .then(response => {


                  this.log('user logged in');

                        //   page.isLoading = false;

                        if (!!response.data) {

                            let ok = !(response.data.IS_ERROR | 0);



                            //   console.log('okkk ' + ok)


                            //  console.log(response.data)



                            response.data.E1 = this.creds.user.trim();
                            response.data.E2 = this.creds.passwd.trim();

                            this.echo('logged_in', response.data);


                            localStorage.setItem('user', JSON.stringify(response.data));

                            this.isLoading = false;
                            setTimeout(()=>{
                                this.$router.push({path: '/client'});
                            },400)

                        }


                    })
                    .catch(error => {


                      this.log('login error ', error);
                        //  console.log(error);


                        //    page.isLoading = false;


                        // Error
                        if (error.response) {


                            // console.log(error.response.data);


                            if (!!error.response.data.IS_ERROR) {


                                this.err = true; //{...error.response.data.Message};
                                this.isLoading = false;
                                //this.verifycode_hint = error.response.data.Message.toString();
                            }

                        }


                        //this.form['verifycode'] = '';
                        //this.$v.form['verifycode'].$touch();

                        //console.log('Network error', error);
                        this.isLoading = false;
                    });






            }


        },


        computed: {


            invalidUser() {
                return this.isDirty && !this.creds['user']
            },

            invalidPassword() {
                return this.isDirty && !this.creds['passwd']
            },

            invalidCreds() {
                return this.isDirty && this.err
            }
        },



        created() {


          this.listen('login_dialog', () => {
              this.modal.show();
          });





        },


        mounted(){


        }


        //bu
    }



</script>
<style scoped>
  .back{
    border-color: #045439;
    color: #045439;
    width: 13rem;
  }
  .back:hover{
    color: white;
    background-color: #045439;
  }
  .container{
    padding-top: 4rem;
    padding-bottom: 6rem;
  }
  .title{
    padding-top: 45px;
  }
  .PopupLogin{
    height: 60px;
  }
  .dialog{
    width: 100%;
    display: inline-block;
    background-color: #fcfcfc;
    border-radius: 3rem;
    border: 1px solid #ced4da;
  }
  a.login {

    width:11rem;
  }
  input{
    border: 1px solid #ced4da;
  }
  .PopupLogin {
    position: relative;
  }
  .row{
    padding-bottom: 4.5%;
  }
  .PopupLogin input {
    padding-right: 35px !important;
  }
  .Inputs{
    align-content: center;
    text-align: center;
    display: inline-block;
    width: 70%;
  }
  .PopupLogin i {
    opacity: .5;
    position: absolute;
    right: 0px;
    padding: 17px 20px;
    pointer-events: none;
  }






  b-button {
    width: 250px;
    height: 40px;
    color: white;
    background-color: forestgreen;
    display: flex;
    justify-content: center;
  }

  h5 {
    justify-content: center;
  }
  @media(max-width: 481px){
    .loginRow{
      padding-top: 0;
    }
    .zalogujRow{
      padding-top: 10px;
    }
    .PopupLogin{
      height: 50px;
    }
    .d-flex{
      padding-bottom: 13px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/MCLoginPage.vue